export default __webpack_public_path__ + "static/media/Form.a7447162.jpg";